import React from 'react';

export const context = React.createContext({});

export const Provider = context.Provider;
export const Consumer = context.Consumer;
export const key = (key, messages = {}) => messages[key] || key;

export const connect = ({ fn = 't' } = {}) => Component => props => (
  <Consumer>
    {messages => (
      <Component
        {...props}
        messages={messages}
        {...{ [fn]: v => key(v, messages) }}
      />
    )}
  </Consumer>
);



// WEBPACK FOOTER //
// /app/apps/ms/src/i18n/react.js